export const footerNavLinks = [
  {
    id: 1,
    title: "Useful Links",
    links: [
      {
        id: 1,
        name: "Admissions process",
        link: "/",
      },
      {
        id: 2,
        name: "Bologna Process",
        link: "/",
      },
      {
        id: 3,
        name: "Arrival&Pick-Up",
        link: "/",
      },
      {
        id: 4,
        name: "Overseas Representatives",
        link: "/",
      },
    ],
  },
  {
    id: 2,
    title: "Adress MSMB",
    links: [
      {
        id: 1,
        name: "Street: 151 triq Edgar Bernard",
      },
      {
        id: 2,
        name: "City: Gzira",
      },
      {
        id: 3,
        name: "Gzira Country: Malta",
      },
      {
        id: 4,
        name: "Post-cod: GZR 1707",
      },
    ],
  },
  {
    id: 3,
    title: "Contacts",
    links: [
      {
        id: 1,
        name: "Admissions department:",
      },
      {
        id: 2,
        name: "+356 7765 95 55 (Tel/WhatsApp)",
        link: "/",
      },
      {
        id: 3,
        name: "Cooperations department:",
      },
      {
        id: 4,
        name: "+356 7765 95 44 (Tel/WhatsApp)",
        link: "/",
      },
    ],
  },
  {
    id: 4,
    title: "Social link",
    links: [
      {
        id: 1,
        name: "Facebook",
        link: "/",
      },
      {
        id: 2,
        name: "Instagram",
        link: "/",
      },
      {
        id: 3,
        name: "Tiktok",
        link: "/",
      },
      {
        id: 4,
        name: "YouTube",
        link: "/",
      },
    ],
  },
];
